import React, { useRef, useCallback } from 'react'

import AtomicSDK, { AACStreamContainer } from '@atomic.io/action-cards-web-sdk'
import { useAtomic } from './AtomicProvider'
import { Box, styled } from '@mui/material'

const AtomicStyleWrapper = styled(Box)`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  /* display: flex; */
  .atomic-sdk-frame {
    width: 100%;
  }
`

interface AtomicEmbedProps {
  containerId: string
}

const AtomicEmbedSingleCard: React.FC<AtomicEmbedProps> = ({ containerId }) => {
  const { atomicReady, onLinkButtonPressed } = useAtomic()

  // Create a reference to the embedded stream container
  const embedRef = useRef<AACStreamContainer>()
  const [cardCount, setCardCount] = React.useState(0)

  const singleCardEmbed = useCallback(
    (el: HTMLDivElement) => {
      if (!atomicReady) {
        return
      }
      if (embedRef.current) {
        // Clean up any existing instance we might have
        embedRef.current.stop()
      }
      if (el && atomicReady) {
        el.innerHTML = ''

        AtomicSDK.singleCard(el, {
          streamContainerId: containerId,
          enabledUiElements: {
            launcherButton: {
              disabled: true,
            },
          },
          onCardCountChanged: (cardCount, totalCards) => {
            // console.debug('Card count is now', count)
            setCardCount(totalCards)
          },
          // onCardEvent(event) {
          //   // alert(event)
          // },
          onLinkButtonPressed(payload) {
            onLinkButtonPressed(payload)
          },
          // onLauncherToggled(open) {
          //   // alert(open)
          // },
          // onSubmitButtonPressed(payload) {
          //   // alert(payload)
          // },
        })
      }
    },
    [atomicReady],
  )

  if (!atomicReady) {
    return null
  }

  const display = cardCount === 0 ? { display: 'none' } : {}

  return (
    <AtomicStyleWrapper sx={display} ref={singleCardEmbed} className='atomic-embed-single-card' />
  )
}

export default AtomicEmbedSingleCard
